'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelCase;

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _camelCase = require('lodash/camelCase');

var _camelCase2 = _interopRequireDefault(_camelCase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleObject(obj) {
  var newObj = {};
  (0, _forOwn2.default)(obj, function (val, key) {
    // eslint-disable-next-line no-use-before-define
    newObj[(0, _camelCase2.default)(key)] = camelCaseKeys(val);
  });
  return newObj;
}

function camelCaseKeys(value) {
  if ((0, _isArray2.default)(value)) {
    return value.map(camelCaseKeys);
  } else if ((0, _isObject2.default)(value)) {
    return handleObject(value);
  }
  return value;
}

function camelCase(data) {
  if (!(0, _isEmpty2.default)(data) && !(0, _isString2.default)(data)) {
    /**
     * It seems that 'camelcase-object' will not handle arrays that aren't bound to an object key -
     * if they are not part of an object, but are themselves THE object, the library will bork -
     * it'll actually transform the array into an object, where the index of the position of an
     * object in the array, becomes that object's key in the object that camelcase-object creates.
     * This is not proper behavior. In order to get around this, if the data object here is itself
     * an array, traverse through it and map the individual object transforms.
     *
     * Only doing this for top level arrays right now - in all other situations, an array will be
     * part of an object, bounded to a key.
     */
    if ((0, _isArray2.default)(data)) {
      return data.map(function (obj) {
        return camelCaseKeys(obj);
      });
    }

    return camelCaseKeys(data);
  }

  return data;
}
//# sourceMappingURL=camelCase.js.map